<template>
<div class="app has-header">
    <div class="header">
        <menutabs :state="{tabs: tabs}" :tab-selected="tabSelected" @tab-select="UpdateSelectedView"></menutabs>
    </div>
    <component :is="tabSelected.view"/>
</div>
</template>

<script>


import planningindicatoroverview from '../planningindicatorcontext/PlanningIndicatorOverview.vue'

import crewlaborplanning from '../planningindicatorcontext/CrewLaborPlanning.vue'
import statisticsoverview from '../planningindicatorcontext/StatisticsOverview.vue'
import projectoverview from '../shiftcontext/ProjectOverview.vue'
import forecastoverview from '../planningindicatorcontext/ForecastOverview.vue'
import forecasttargetoverview from '../planningindicatorcontext/ForecastTargetOverview.vue'
import fixedcostoverview from '../planningindicatorcontext/FixedCostOverview.vue'


import { mapState, mapGetters } from 'vuex';
export default {
    components: {
        planningindicatoroverview,
        crewlaborplanning,
        statisticsoverview,
        forecastoverview,
        fixedcostoverview,
        projectoverview,
        forecasttargetoverview

    },
    name: 'PlanningIndicatorMain',
    data() {
        return {
            loading: true,
            
            tabSelected: null,
        }
    },
    computed: {
        ...mapGetters(['storeId', 'isSuperUser', 'storeSettings', 'userInfo']),
        tabs() {
            let tabs = [{label: this.$t('indicator.main.planning'), view: 'planningindicatoroverview', selected: true, margin: true}];
            if(this.storeSettings && !this.storeSettings.simpleMode){
                tabs.push({label: this.$t('indicator.main.productivity'), view: 'crewlaborplanning', margin: true});
                tabs.push({label: this.$t('shift.plan.project'), view: 'projectoverview', margin: true});
                
                   
                tabs.push({label: this.$t('indicator.main.fixCosts'), view: 'fixedcostoverview', margin: true});
                tabs.push({label: this.$t('indicator.main.evaluation'), view: 'statisticsoverview', margin: true});
                if(this.storeId == 441 || this.isSuperUser){
                    tabs.push({label: this.$t('indicator.main.forecastTarget'), view: 'forecasttargetoverview', margin: true, 'onlyAdmin' : true});
                }
                if(this.isSuperUser || this.userInfo.id == 'ba8c0912-a75d-47e1-b959-35a53bb8356e'){
                    
                    tabs.push({label: this.$t('indicator.main.forecast'), view: 'forecastoverview', margin: true, 'onlyAdmin' : true});
                }
            }   
            return tabs;
           
        }
    },
    watch: {},
    props: {
        view: String,
    },
    created() {
        let view = this;
        if(this.$router.currentRoute.params.tab){
            let tab = this.tabs.find(t => t.view === view.$router.currentRoute.params.tab);
            if(tab){
                this.tabSelected = tab;
            }
        } else {
            let tab = this.tabs.find(t => t.selected);
            if(tab) this.tabSelected = tab;
            else this.tabSelected = {view: this.view ? this.view : 'planningindicatoroverview'};
        }
    },
    mounted(){

    },
    updated() {},
    destroyed() {},
    methods: {
        UpdateSelectedView(tab){
            this.tabs.forEach(t => t.selected = false);
            tab.selected = true;
            this.tabSelected = tab;
        }
    }
}
</script>
